import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MaterialModule } from './material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CookieService } from 'ngx-cookie-service';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';

import { PipesModule } from '../pipes/pipes.module';

import { FuseConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { FuseCountdownComponent } from '../components/countdown/countdown.component';
import { ToastComponent } from '../components/toast/toast.component';
import { FuseHighlightComponent } from '../components/highlight/highlight.component';
import { FuseMaterialColorPickerComponent } from '../components/material-color-picker/material-color-picker.component';

import { FuseMatchMedia } from '../services/match-media.service';
import { FuseTranslationLoaderService } from '../services/translation-loader.service';
import { FuseMatSidenavHelperService } from '../directives/fuse-mat-sidenav-helper/fuse-mat-sidenav-helper.service';

import { FusePerfectScrollbarDirective } from '../directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseIfOnDomDirective } from '../directives/fuse-if-on-dom/fuse-if-on-dom.directive';
import { FuseMatSidenavHelperDirective, FuseMatSidenavTogglerDirective } from '../directives/fuse-mat-sidenav-helper/fuse-mat-sidenav-helper.directive';


@NgModule({
    declarations: [
        FuseConfirmDialogComponent,
        FuseCountdownComponent,
        ToastComponent,
        FuseHighlightComponent,
        FuseMaterialColorPickerComponent,
        FuseIfOnDomDirective,
        FusePerfectScrollbarDirective,
        FuseMatSidenavHelperDirective,
        FuseMatSidenavTogglerDirective,

    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MaterialModule,
        FlexLayoutModule,
        ColorPickerModule,
        NgxDnDModule,
        NgxDatatableModule,
        ChartsModule,
        PipesModule,
    ],
    exports: [
        FlexLayoutModule,
        MaterialModule,
        CommonModule,
        FormsModule,
        FuseMatSidenavHelperDirective,
        FuseMatSidenavTogglerDirective,
        PipesModule,
        FuseCountdownComponent,
        ToastComponent,
        FuseHighlightComponent,
        FusePerfectScrollbarDirective,
        ReactiveFormsModule,
        ColorPickerModule,
        NgxDnDModule,
        NgxDatatableModule,
        FuseIfOnDomDirective,
        FuseMaterialColorPickerComponent,
        TranslateModule,
        ChartsModule
    ],
    entryComponents: [
        FuseConfirmDialogComponent
    ],
    providers: [
        CookieService,
        FuseMatchMedia,
        FuseMatSidenavHelperService,
        FuseTranslationLoaderService,
        ToastComponent
    ]
})

export class SharedModule {

}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/core/modules/shared.module.ts